"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToObject = exports.every = exports.forEach = void 0;
/**
 * A specialized version of `forEach` for arrays.
 *
 * From lodash.
 */
function arrayEach(array, iteratee) {
    let index = -1;
    const length = array.length;
    while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
            break;
        }
    }
    return array;
}
/**
 * A specialized version of `forEach` for objects.
 */
function objectEach(source, iteratee) {
    for (let key in source) {
        /* istanbul ignore next */
        if (source.hasOwnProperty(key)) {
            if (iteratee(source[key], key, source) === false) {
                break;
            }
        }
    }
    return source;
}
function forEach(source, iteratee) {
    const func = Array.isArray(source) ? arrayEach : objectEach;
    return func(source, iteratee);
}
exports.forEach = forEach;
function every(source, predicate) {
    let result = true;
    forEach(source, (value, key, source) => {
        if (!predicate(value, key, source)) {
            result = false;
            return false;
        }
    });
    return result;
}
exports.every = every;
/**
 * Creates an object hash from a map.
 *
 * @param map
 */
function mapToObject(map) {
    const result = {};
    const entries = Array.from(map.entries());
    for (let index = 0; index < entries.length; index++) {
        const [key, value] = entries[index];
        result[key] = value;
    }
    return result;
}
exports.mapToObject = mapToObject;
//# sourceMappingURL=utils.js.map